import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import supabase from '@/lib/supabaseClient';
import { parseStaffFragment } from '@/lib/staffSession';

// Landing page for a staff session link from the Provider Portal: sign in with the tokens, then go to the dashboard.
const StaffSession = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const tokens = parseStaffFragment(window.location.hash);
    // Remove the tokens from the address bar and history straight away.
    window.history.replaceState(null, '', window.location.pathname);
    if (!tokens) {
      setError('This staff session link is not valid. Open it again from the Provider Portal.');
      return;
    }
    supabase.auth
      .setSession({ access_token: tokens.accessToken, refresh_token: tokens.refreshToken })
      .then(({ error: sessionError }) => {
        if (sessionError) setError('The staff session could not be started. Open it again from the Provider Portal.');
        else navigate('/', { replace: true });
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="p-8" data-testid="staff-session-error">
        <p>{error}</p>
        <Link to="/login">Go to sign in</Link>
      </div>
    );
  }
  return <div className="p-8" role="status" data-testid="staff-session-loading">Starting staff session…</div>;
};

export default StaffSession;
